export const colors = {
  primary1: '#4A637B',
  secondary1: '#daf0ff',
  // secondary: '#add7e6',
  // #add7e6
  background1: '#f4f4f4',
  black1: '#000000',
  bg1: '#D9D9D950',
  btn1: '#8E44AD33',
  txt1: '#000000',
  toast_error1: 'bg-red-500',
  toast_success1: "bg-green-500",
  white1: '#ffffff', // white
  green:'#008000'
};
